import * as React from 'react'
import styled from 'styled-components'

const Error = styled.span({
  color: '#FF6D6D',
})

const Info = styled.span({
  color: '#5EBB85',
})

const Default = styled.span({})

type Props = {
  message: string
  error?: boolean
  info?: boolean
}

const Alert: React.FC<Props> = function ({ message, error, info }) {
  return (
    <div
      style={{
        padding: '5px 0',
      }}
    >
      {error ? (
        <Error>{message}</Error>
      ) : info ? (
        <Info>{message}</Info>
      ) : (
        <Default>{message}</Default>
      )}
    </div>
  )
}

export default Alert
